import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import { Redirect } from 'react-router-dom';
import { Navigate, useNavigate } from 'react-router-dom';

import { login } from '../actions/auth';

const OneLogin = (props) => {
  const navigate = useNavigate();

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [param1, setParam1] = useState('');

  const { isLoggedIn } = useSelector((state) => state.auth);
  const { message } = useSelector((state) => state.message);

  const dispatch = useDispatch();

  useEffect(() => {
    // window.location.assign('http://localhost:3000');
    // window.location.assign('/api/onelogin');
    // <Link to="/app/onelogin/">...</Link>;

    //ส่งมาจาก users.js
    const queryParams = new URLSearchParams(window.location.search);
    const param1 = queryParams.get('ret');
    const username = queryParams.get('u');

    // console.log("-- Onelogin.js -- username --", username);

    // setUsername('1310600146681');
    setUsername(username);
    setPassword('test1234');
    setParam1(param1);

    dispatch(login(username, password, param1))
      .then(() => {

        navigate('/app/employment');
        
        // props.history.push('/');
        // props.history.push('/ninja');

        // console.log('---OneLogin.js---');
        // const timer = setTimeout(() => console.log('--redirect--'), 10000);
        // return () => {
        //   navigate('/app/employment');
        // };

        // window.location.assign('/app/employment');
        // history.push('/app/employment');
        // props.history.push('/app/employment');
        // window.location.reload();
        // <a href={'/api/onelogin/login'} className="nav-link">OneLogin</a>
        // <Navigate to="/app/employment" />;
      })
      .catch(() => {
        // setLoading(false);
        navigate('/app');
      });
  }, [param1]);

  // if (isLoggedIn) {
  //   return <Navigate to="/app/employment" />;
  // }

  return <div>...</div>;
};

export default OneLogin;
